import { useEffect, useState } from "react";

const todayStr = () => new Date().toISOString().slice(0, 10);

// Menyimpan pilihan periode + rentang tanggal ke localStorage per halaman
// agar tidak reset ke periode berjalan saat halaman di-refresh.
export function usePersistentPeriod(pageKey, defaultPeriod = "month") {
  const [period, setPeriod] = useState(() => {
    try { return localStorage.getItem(`pf_period_${pageKey}`) || defaultPeriod; } catch { return defaultPeriod; }
  });
  const [range, setRange] = useState(() => {
    try {
      const raw = localStorage.getItem(`pf_range_${pageKey}`);
      if (raw) { const p = JSON.parse(raw); if (p && p.start && p.end) return p; }
    } catch { /* abaikan */ }
    return { start: todayStr(), end: todayStr() };
  });
  useEffect(() => { try { localStorage.setItem(`pf_period_${pageKey}`, period); } catch { /* abaikan */ } }, [pageKey, period]);
  useEffect(() => { try { localStorage.setItem(`pf_range_${pageKey}`, JSON.stringify(range)); } catch { /* abaikan */ } }, [pageKey, range]);
  return [period, setPeriod, range, setRange];
}
